/**
 * User: liliana
 * Date: 4/17/15
 * Time: 11:32 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');

var Favorites = module.exports = SoaCollection.extend();

var _            = require('underscore');
var Favorite     = require('bunsen/models/identity/Favorite');
var endpoints    = require('dibs-endpoints');

_.extend(Favorites.prototype, {
    url : endpoints.favorites,
    model : Favorite
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/identity/Favorites.js
// module id = 1204
// module chunks = 62